import React from "react";
import {
  MessageDialogContainer,
  AboutSoftwareDialogContainer,
  UserPreferencesDialogContainer,
} from "pages/viewer-dashboard/container";

interface IDialogSectionProps {}
interface IDialogSectionStates {}

function DialogSection(
  props: IDialogSectionProps,
  state: IDialogSectionStates
) {
  return (
    <>
      <MessageDialogContainer />
      <AboutSoftwareDialogContainer
        userID=""
        item=""
        model=""
        version=""
        companyAddress=""
        manufacturingPermitNumber=""
        serialNumber=""
        UDI=""
        website=""
        show={true}
      />
      <UserPreferencesDialogContainer show={true} />
    </>
  );
}

export default DialogSection;
